<template>
  <div class="box">
    <Header title="今日快照"></Header>
    <div class="show-box">
      <div class="title-card"></div>
      <div class="header-info">
        <div class="header-info-box">
          <div class="header-info-detail">
            <div class="header-info-title">支付金额</div>
            <div class="header-info-unit">(万元/日)</div>
            <div class="header-info-content">
              <countTo
                :startVal="0"
                :endVal="this.transactionAmt ? Number(this.transactionAmt) : 0"
                :duration="2000"
                :decimals="2"
                separator
              ></countTo>
            </div>
          </div>
          <div class="header-info-detail" style="border-right: unset">
            <div class="header-info-title">下单用户</div>
            <div class="header-info-unit">(日/月)</div>
            <div class="header-info-content0">
              <countTo
                :startVal="0"
                :endVal="this.todayUserCount ? Number(this.todayUserCount) : 0"
                :duration="2500"
                separator
              ></countTo>
              <div>/</div>
              <countTo
                :startVal="0"
                :endVal="
                  this.todayWeekUserCount ? Number(this.todayWeekUserCount) : 0
                "
                :duration="2500"
                separator
              ></countTo>
            </div>
          </div>
        </div>
        <div class="header-date-box">
          <div class="container">
            <div class="re-box">
              <div class="re-item">
                <div class="re-item-front">
                  <div class="header-date-mm" v-text="month"></div>
                  <div class="header-date-dd">
                    <countTo
                      :startVal="0"
                      :endVal="this.today ? Number(this.today) : 0"
                      :duration="2500"
                      separator
                    ></countTo>
                  </div>
                  <img src="../assets/images/today-date.png" alt />
                </div>
                <div class="re-item-back">
                  <div class="header-date-mm" v-text="month"></div>
                  <div class="header-date-dd">
                    <countTo
                      :startVal="0"
                      :endVal="this.today ? Number(this.today) : 0"
                      :duration="2500"
                      separator
                    ></countTo>
                  </div>
                  <img src="../assets/images/today-date.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div
            class="system-date"
            v-text="'系统运行' + systemDate + '天'"
          ></div>
        </div>
      </div>
      <div class="orderCsh-box">
        <van-field
          class="csh-box"
          v-model="orderCsh"
          :readonly="true"
          input-align="center"
          right-icon="wap-nav"
          placeholder="请选择区域"
          @click="searchCsh()"
        />
      </div>
      <div class="echart-box">
        <van-swipe indicator-color="red">
          <van-swipe-item>
            <div class="order-chart" ref="orderChart1"></div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="order-chart" ref="orderChart3"></div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="order-search-box">
        <div class="order-search-left">
          <img class="left-img" src="../assets/images/today-search.png" alt />
        </div>
        <div class="order-search-center">
          <van-search
            class="top-search"
            v-model="searchValue"
            shape="round"
            clearable
            left-icon
            background="none"
            placeholder="请输入订单号/客户名称"
            @search="
              pageNo = 0;
              orderList = [];
              finished = false;
              searchHandle();
            "
          />
        </div>
        <div class="order-search-right">
          <img
            class="right-img"
            src="../assets/images/search.png"
            alt
            @click="
              pageNo = 0;
              orderList = [];
              finished = false;
              searchHandle();
            "
          />
        </div>
      </div>
      <div class="tab-box">
        <van-tabs
          v-model="activeName"
          animated
          type="line"
          @click="handleClick"
        >
          <van-tab
            v-for="(item, index) in orderStatusList"
            :title="item.orderStatusName"
            :key="index"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="order-list-box">
        <div class="list-box">
          <div class="list-title" v-if="!noData">
            <div class="list-title-orderNo">订单号<br />(DBU区域)</div>
            <div class="list-title-customer">客户名称</div>
            <div class="list-title-date">时间</div>
            <div class="list-title-status">状态</div>
            <div class="list-title-amt">金额</div>
          </div>
          <van-list
            class="list-ul"
            finished-text="没有更多了"
            :finished="finished"
            v-model="loading"
            v-if="!noData"
            offset="10"
            @load="searchHandle()"
          >
            <li
              class="list-li"
              v-for="(item, index) in orderList"
              :key="index"
              @click="clickToPageDetail(item.codeno)"
            >
              <div style="width: 25%">
                <div class="list-content1" v-text="item.codeno"></div>
                <div class="list-content1" v-text="item.cshName"></div>
              </div>
              <div
                class="list-content"
                style="width: 25%"
                v-text="item.displayName"
              ></div>
              <div
                class="list-content"
                style="width: 18%"
                v-text="item.orderDate"
              ></div>
              <div
                class="list-content orderState"
                :style="{
                  width: '14%',
                  color:
                    item.orderStateName == '未支付' ||
                    item.orderStateName == '待审核' ||
                    item.orderStateName == '已拒绝'
                      ? '#da291c'
                      : '',
                }"
                v-text="item.orderStateName"
              ></div>
              <div
                class="list-content"
                style="padding-right: 0px; width: 18%"
                v-text="item.productMoney"
              ></div>
            </li>
          </van-list>
        </div>
      </div>
    </div>
    <van-popup v-model="cshShow" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="cshList"
        :default-index="0"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script src="path/tojquery.flip.js"></script>
<script>
import $ from "jquery";
import echarts from "echarts";
import { getCshlist, getHeaderData, getOrderList } from "@/api/today";
import { STATUS_CODE_OK } from "@/config";
import store from "@/store";
import { mapActions } from "vuex";
import countTo from "vue-count-to";
import Header from "@/components/Header";
export default {
  name: "today",
  data() {
    return {
      //头部数据
      transactionAmt: "",
      orderAmt: "",
      todayUserCount: "",
      todayWeekUserCount: "",
      today: "",
      month: "",
      systemDate: "",
      //CSH查询
      cshNo: "",
      orderCsh: "",
      userCode: "",
      cshShow: false,
      cshList: [],
      //支付金额E-chart图表
      weekTradeXdata: [],
      monthTradeXdata: [],
      yearTradeXdata: [],
      weekTradeYdata: [],
      monthTradeYdata: [],
      yearTradeYdata: [],
      //下单用户E-chart图表
      weekMemberXdata: [],
      weekMemberYdata: [],
      monthMemberXdata: [],
      monthMemberYdata: [],
      yearMemberXdata: [],
      yearMemberYdata: [],
      //订单查询
      searchValue: "",
      pageNo: 0,
      displayCount: 10,
      loading: false,
      finished: false,
      refreshing: false,
      noData: false,
      orderList: [],
      echartsWidth: 0,
      activeName: "",
      orderStatusId: "",
      orderStatusItem: {},
      orderStatusList: [],
    };
  },
  mounted() {
    //初期获取手机屏幕宽度
    this.echartsWidth = $(document.body).width() - 30;
    this.echartsWidth = this.echartsWidth + "px";
    $(".order-chart").css("width", this.echartsWidth);
    //初期获取全局usercode
    this.userCode = store.getters.userCode;
    //初期获取CSH列表数据
    this.getCsh();
    //订单详情页面返回获取CSH
    if (store.getters.cshPicker) {
      this.cshNo = store.getters.cshPicker.value;
      this.orderCsh = store.getters.cshPicker.text;
    }
    //订单详情页面返回获取订单状态筛选
    if (store.getters.orderStatusList) {
      this.orderStatusId = store.getters.orderStatusList.orderStatusCode;
    }
    //订单详情页面返回获取订单状态筛选Index
    if (store.getters.name) {
      this.activeName = store.getters.name;
    }
    //初期获取头部/E-chart图表数据
    this.getInfo(this.cshNo);
  },
  methods: {
    //获取CSH列表数据
    async getCsh() {
      let { data } = await getCshlist({
        userCode: this.userCode,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        //获取 CSH下拉列表数据
        for (var i = 0; i < data.cshOrderStsInfoVo.userCshListVo.length; i++) {
          if (data.cshOrderStsInfoVo.userCshListVo.length > 1) {
            if (i == 0) {
              var cshItem0 = {
                value: "",
                text: "",
              };
              cshItem0.value = "";
              cshItem0.text = "全部";
              this.cshList.push(cshItem0);
            }
          }
          var cshItem = {
            value: "",
            text: "",
          };
          cshItem.value = data.cshOrderStsInfoVo.userCshListVo[i].cshId;
          cshItem.text = data.cshOrderStsInfoVo.userCshListVo[i].cshName;
          this.cshList.push(cshItem);
        }
        //获取 订单状态列表数据
        for (var j = 0; j < data.cshOrderStsInfoVo.orderStsListVo.length; j++) {
          if (j == 0) {
            var orderStatusItem0 = {
              orderStatusCode: "",
              orderStatusName: "",
            };
            orderStatusItem0.orderStatusCode = "";
            orderStatusItem0.orderStatusName = "全部";
            this.orderStatusList.push(orderStatusItem0);
          }
          var orderStatusItem = {
            orderStatusCode: "",
            orderStatusName: "",
          };
          orderStatusItem.orderStatusCode =
            data.cshOrderStsInfoVo.orderStsListVo[j].orderStsNo;
          orderStatusItem.orderStatusName =
            data.cshOrderStsInfoVo.orderStsListVo[j].orderStsName;
          this.orderStatusList.push(orderStatusItem);
        }
      }
    },
    //选择 CSH 列表
    searchCsh() {
      this.cshShow = true;
    },
    //选择 CSH 列表-取消
    onCancel() {
      this.cshShow = false;
    },
    //选择 CSH 列表-确认
    onConfirm(picker) {
      this.cshShow = false; //确认后关闭底部弹框FLG
      this.cshNo = picker.value; // cshCode
      this.orderCsh = picker.text; // csh名称
      //把选中CSH设定到localStorage
      this.setCshPicker(picker);
      //切换确认CSH 获取对应CSH的Header部数据/E-chart展示数据
      this.getInfo(this.cshNo);
      //切换确认CSH 获取对应CSH的订单列表展示数据
      this.pageNo = 0;
      this.orderList = [];
      this.finished = false;
      this.searchHandle();
    },

    //点击 订单状态 筛选
    handleClick(name) {
      this.orderStatusId = this.orderStatusList[name].orderStatusCode;
      this.setOrderStatus(this.orderStatusList[name]);
      this.setOrderStatusIndex(name);
      this.pageNo = 0;
      this.orderList = [];
      this.finished = false;
      this.searchHandle(this.orderStatusId);
    },

    //获取Header部/E-chart展示数据
    async getInfo() {
      var myDate = new Date();
      var startDate = new Date("2020/01/06 00:00:00");
      this.today = myDate.getDate(); //日历-日
      this.month = myDate.toDateString().split(" ")[1]; //日历-月(英文)
      var s1 = myDate.getTime();
      var s2 = startDate.getTime();
      var total = (s1 - s2) / 1000;
      this.systemDate = parseInt(total / (24 * 60 * 60)); //计算整数天数
      //jQuery日历卡片自动翻牌特效
      $(function () {
        flip();
      });
      function flip() {
        var timer = null;
        var i = 0;
        var j = 0;
        var aFlip = $(".container");
        function flipFn(arg1, arg2) {
          aFlip.eq(i).toggleClass("card-flipped");
          i++;
          if (i < 1) {
            i = 0;
          } //i<1 初期只翻转一次结束自动翻转
        }
        timer = setInterval(flipFn, 500); //控制翻转时间
      }

      // 支付金额E-hart图表
      this.orderChart1 = echarts.init(this.$refs.orderChart1);
      this.orderChart1.setOption({
        title: [
          {
            text: "支付金额(万元)",
            padding: [20, 0, 0, 5],
            textStyle: {
              color: "#000",
              fontSize: 14,
              fontFamily: "Helvetica",
            },
          },
        ],
        grid: {
          left: "15px",
          right: "10%",
          top: "60px",
          bottom: "6%",
          containLabel: true,
        },
        legend: {
          data: ["周", "月", "年"],
          selectedMode: "single",
          orient: "horizontal",
          selected: {
            周: false,
            月: true,
            年: false,
          },
          icon: "roundRect",
          inactiveColor: "#999",
          x: "right",
          y: "top",
          itemWidth: 25,
          itemHeight: 10,
          padding: [20, 15, 5, 0],
          textStyle: {
            fontSize: 12,
            color: "#000",
          },
          itemGap: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              show: false,
            },
          },
          confine: true,
          extraCssText: "font-size: 12px; text-align: left;",
          position: function (point, params, dom, rect, size) {
          // position: function (point, params, dom) {
            dom.style.transform = "translateZ(0)";
          },
          formatter: function (params) {
            var tooltipData = "";
            var datalength = params[0]["data"].allCsh.length;
            var dotHtml =
              '<span style="display:inline-block;margin:0px 5px 0px 10px;border-radius:5px;width:5px;height:5px;background-color:#eeeeee"></span>';
            for (var i = 0; i < datalength; i += 2) {
              if (params[0]["data"].allCsh[i]) {
                tooltipData +=
                  dotHtml +
                  params[0]["data"].allCsh[i].name +
                  ": " +
                  params[0]["data"].allCsh[i].value +
                  "万元";
              }
              if (params[0]["data"].allCsh[i + 1]) {
                tooltipData +=
                  dotHtml +
                  params[0]["data"].allCsh[i + 1].name +
                  ": " +
                  params[0]["data"].allCsh[i + 1].value +
                  "万元</br>";
              }
            }
            if (datalength > 0) {
              return (
                dotHtml +
                params[0]["data"].name +
                ": " +
                params[0]["data"].value +
                "万元" +
                "</br>" +
                tooltipData
              );
            } else {
              return (
                dotHtml +
                params[0]["data"].name +
                ": " +
                params[0]["data"].value +
                "万元"
              );
            }
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.monthTradeXdata,
            axisLine: {
              show: false, //x轴
            },
            axisTick: {
              show: false, //x轴刻度线
            },
            axisLabel: {
              showMaxLabel: true, //显示最大刻度值
            },
          },
        ],
        yAxis: {
          type: "value",
          axisLine: {
            show: false, //y轴
          },
          axisTick: {
            show: false, //y轴刻度线
          },
          splitLine: {
            show: true, //y轴网格线
          },
        },
        series: [
          {
            name: "周",
            type: "line",
            data: this.weekTradeYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#da291c",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#da291c" },
                  { offset: 1, color: "#eeeeee" },
                  { offset: 1, color: "#dcdcdc" },
                ]),
              },
            },
          },
          {
            name: "月",
            type: "line",
            data: this.monthTradeYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#da291c",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#da291c" },
                  { offset: 1, color: "#eeeeee" },
                  { offset: 1, color: "#dcdcdc" },
                ]),
              },
            },
          },
          {
            name: "年",
            type: "bar",
            data: this.yearTradeYdata,
            barWidth: "10%", //柱图宽度
            markPoint: {
              symbol: "pin",
            },
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              borderWidth: "10",
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#da291c" },
                { offset: 1, color: "#eeeeee" },
                { offset: 1, color: "#dcdcdc" },
              ]),
            },
          },
        ],
      });
      // 下单用户数量E-hart图表
      this.orderChart3 = echarts.init(this.$refs.orderChart3);
      this.orderChart3.setOption({
        title: [
          {
            text: "下单用户",
            padding: [20, 0, 0, 5],
            textStyle: {
              color: "#000",
              fontSize: 14,
              fontFamily: "Helvetica",
            },
          },
        ],
        grid: {
          left: "15px",
          right: "10px",
          top: "60px",
          bottom: "6%",
          containLabel: true,
        },
        legend: {
          data: ["周", "月", "年"],
          selectedMode: "single",
          orient: "horizontal",
          selected: {
            周: false,
            月: true,
            年: false,
          },
          icon: "roundRect",
          inactiveColor: "#999",
          x: "right",
          y: "top",
          itemWidth: 25,
          itemHeight: 10,
          padding: [20, 15, 5, 0],
          textStyle: {
            fontSize: 12,
            color: "#000",
          },
          itemGap: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              show: false,
            },
          },
          confine: true,
          extraCssText: "font-size: 12px; text-align: left;",
          position: function (point, params, dom, rect, size) {
          // position: function (point, params, dom) {
            dom.style.transform = "translateZ(0)";
          },
          formatter: function (params) {
            var tooltipData = "";
            var datalength = params[0]["data"].allCsh.length;
            var dotHtml =
              '<span style="display:inline-block;margin:0px 5px 0px 10px;border-radius:5px;width:5px;height:5px;background-color:#eeeeee"></span>';
            for (var i = 0; i < datalength; i += 2) {
              if (params[0]["data"].allCsh[i]) {
                tooltipData +=
                  dotHtml +
                  params[0]["data"].allCsh[i].name +
                  ": " +
                  params[0]["data"].allCsh[i].value;
              }
              if (params[0]["data"].allCsh[i + 1]) {
                tooltipData +=
                  dotHtml +
                  params[0]["data"].allCsh[i + 1].name +
                  ": " +
                  params[0]["data"].allCsh[i + 1].value +
                  "</br>";
              }
            }
            if (datalength > 0) {
              return (
                dotHtml +
                params[0]["data"].name +
                ": " +
                params[0]["data"].value +
                "</br>" +
                tooltipData
              );
            } else {
              return (
                dotHtml +
                params[0]["data"].name +
                ": " +
                params[0]["data"].value
              );
            }
          },
        },
        xAxis: {
          type: "category",
          data: this.monthMemberXdata,
          axisLine: {
            show: false, //x轴
          },
          axisTick: {
            show: false, //y轴刻度线
          },
          axisLabel: {
            showMaxLabel: true, //显示最大刻度值
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false, //y轴
          },
          axisTick: {
            show: false, //y轴刻度线
          },
          splitLine: {
            show: true, //y轴网格线
          },
        },
        series: [
          {
            name: "周",
            type: "line",
            data: this.weekMemberYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#da291c",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#da291c" },
                  { offset: 1, color: "#eeeeee" },
                  { offset: 1, color: "#dcdcdc" },
                ]),
              },
            },
          },
          {
            name: "月",
            type: "line",
            data: this.monthMemberYdata,
            // symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            color: "#da291c",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#da291c" },
                  { offset: 1, color: "#eeeeee" },
                  { offset: 1, color: "#dcdcdc" },
                ]),
              },
            },
          },
          {
            name: "年",
            type: "bar",
            data: this.yearMemberYdata,
            barWidth: "10%", //柱图宽度
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#da291c" },
                { offset: 1, color: "#eeeeee" },
                { offset: 1, color: "#dcdcdc" },
              ]),
            },
          },
        ],
      });
      //点击 周/月/年 切换获取X轴 数据
      // 支付金额E-hart图表
      this.orderChart1.on("legendselectchanged", (obj) => {
        var orderChart1xData = [];
        if (obj.name == "周") {
          orderChart1xData = this.weekTradeXdata;
        } else if (obj.name == "月") {
          orderChart1xData = this.monthTradeXdata;
        } else {
          orderChart1xData = this.yearTradeXdata;
        }
        this.orderChart1.setOption({
          xAxis: [
            {
              data: orderChart1xData,
            },
          ],
        });
      });
      //下单用户数量E-hart图表
      this.orderChart3.on("legendselectchanged", (obj) => {
        var orderChart3xData = [];
        if (obj.name == "周") {
          orderChart3xData = this.weekMemberXdata;
        } else if (obj.name == "月") {
          orderChart3xData = this.monthMemberXdata;
        } else {
          orderChart3xData = this.yearMemberXdata;
        }
        this.orderChart3.setOption({
          xAxis: [
            {
              data: orderChart3xData,
            },
          ],
        });
      });

      //调用后台获取数据
      let { data } = await getHeaderData({
        userCode: this.userCode,
        cshCode: this.cshNo,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        //Header部数据
        this.transactionAmt = data.orderSummaryVo.productMoneyPayed; //支付金额
        this.orderAmt = data.orderSummaryVo.productMoney; //下单金额
        this.todayUserCount = data.orderSummaryVo.orderMemberCount; //下单用户数量（日）
        this.todayWeekUserCount = data.orderSummaryVo.orderMemberMonthCount; //下单用户数量（月）
        //支付金额E-hart图表展示 数据取得
        this.weekTradeXdata =
          data.orderSummaryVo.weekDataTrade.weekMonthYearData;
        this.weekTradeYdata = data.orderSummaryVo.weekDataTrade.data;
        this.monthTradeXdata =
          data.orderSummaryVo.monthDataTrade.weekMonthYearData;
        this.monthTradeYdata = data.orderSummaryVo.monthDataTrade.data;
        this.yearTradeXdata =
          data.orderSummaryVo.yearDataTrade.weekMonthYearData;
        this.yearTradeYdata = data.orderSummaryVo.yearDataTrade.data;
        //下单用户数量E-hart图表轴展示 数据取得
        this.weekMemberXdata =
          data.orderSummaryVo.weekDataMember.weekMonthYearData;
        this.weekMemberYdata = data.orderSummaryVo.weekDataMember.data;
        this.monthMemberXdata =
          data.orderSummaryVo.monthDataMember.weekMonthYearData;
        this.monthMemberYdata = data.orderSummaryVo.monthDataMember.data;
        this.yearMemberXdata =
          data.orderSummaryVo.yearDataMember.weekMonthYearData;
        this.yearMemberYdata = data.orderSummaryVo.yearDataMember.data;
        //支付金额E-hart图表填充
        this.orderChart1.setOption({
          xAxis: [
            {
              data: this.monthTradeXdata,
            },
          ],
          series: [
            {
              data: this.weekTradeYdata,
            },
            {
              data: this.monthTradeYdata,
            },
            {
              data: this.yearTradeYdata,
            },
          ],
        });
        // 下单用户数量E-hart图表填充
        this.orderChart3.setOption({
          xAxis: [
            {
              data: this.monthMemberXdata,
            },
          ],
          series: [
            {
              data: this.weekMemberYdata,
            },
            {
              data: this.monthMemberYdata,
            },
            {
              data: this.yearMemberYdata,
            },
          ],
        });
      }
    },

    // 初期展示全国CSH订单/查询订单/滑动查询订单
    async searchHandle() {
      this.pageNo = this.pageNo + 1;
      let { data } = await getOrderList({
        userCode: this.userCode,
        cshCode: this.cshNo,
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        searchComment: this.searchValue,
        orderSts: this.orderStatusId,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.orderListVoList && data.orderListVoList.length < 1) {
          this.finished = true;
          this.loading = false;
        } else {
          for (var i = 0; i < data.orderListVoList.length; i++) {
            this.orderList.push(data.orderListVoList[i]);
          }
        }
        if (data.orderListVoList.length < this.displayCount) {
          this.finished = true;
        }
      } else {
        this.finished = true;
      }
      this.loading = false;
    },

    //点击订单List数据跳转订单详情页面
    clickToPageDetail(orderNo) {
      this.$router.push({
        name: "orderDetail",
        params: {
          orderNo: orderNo,
        },
      });
    },
    ...mapActions(["setCshPicker", "setOrderStatus", "setOrderStatusIndex"]),
  },
  components: {
    Header,
    countTo,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .header-info {
    display: flex;
    .header-info-box {
      display: flex;
      height: 115px;
      border-radius: 20px;
      width: 72%;
      margin-right: 10px;
      .header-info-detail {
        width: 100%;
        margin: 20px 0px;
        color: #000;
        border-right: 1px solid #dcdcdc;
        .header-info-title {
          font-size: 14px;
          font-weight: bold;
        }
        .header-info-unit {
          font-size: 10px;
          padding-bottom: 10px;
        }
        .header-info-content {
          font-size: 16px;
        }
        .header-info-content0 {
          display: flex;
          font-size: 16px;
          justify-content: center;
        }
      }
    }
    .header-date-box {
      height: 115px;
      width: 23%;
      .container {
        flex-grow: 1;
        flex-basis: 0;
        display: flex;
        flex-direction: column;
        position: relative;
      }
      .re-box {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 1s ease;
        -webkit-transition: all 1s ease;
      }
      .re-item {
        position: relative;
        perspective: 1000;
        -webkit-perspective: 1000;
        perspective: 1000;
        -webkit-perspective: 1000;
      }
      .re-item img {
        width: 75px;
        margin: 0px 5px 5px 5px;
      }
      .re-item-front,
      .re-item-back {
        left: 0;
        top: 55px;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        -ms-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -o-backface-visibility: hidden;
        overflow: hidden;
        transition: all 1.5s ease;
        -webkit-transition: all 1.5s ease;
        -moz-transition: all 1.5s ease;
        -ms-transition: all 1.5s ease;
        -o-transition: all 1.5s ease;
      }

      .re-item-front {
        position: absolute;
        transform: rotateX(0deg);
        -webkit-transform: rotateX(0deg);
      }
      .re-item-back {
        position: relative;
        transform: rotateX(-180deg);
        -webkit-transform: rotateX(-180deg);
      }
      .card-flipped .re-item-back {
        transform: rotateX(-360deg);
        -webkit-transform: rotateX(-360deg);
      }
      .card-flipped .re-item-front {
        transform: rotateX(-180deg);
        -webkit-transform: rotateX(-180deg);
      }

      .header-date-mm {
        position: absolute;
        left: 0;
        right: 0;
        padding-top: 15px;
        font-size: 12px;
        color: #eeeeee;
      }
      .header-date-dd {
        position: absolute;
        left: 0;
        right: 0;
        top: 25px;
        line-height: 55px;
        font-size: 30px;
        color: #eeeeee;
      }
      .system-date {
        text-align: center;
        padding-top: 95px;
        font-size: 10px;
      }
    }
  }
  .orderCsh-box {
    display: flex;
    justify-content: flex-end;
    height: 35px;
    margin: 5px 0px;
    .csh-box {
      padding: 0px;
      background: unset;
      /deep/ .van-field__control {
        text-align: right;
      }
    }
  }
  .echart-box {
    width: 100%;
    height: 330px;
    border-radius: 20px;
    .order-chart {
      padding: 5px;
      height: 330px;
    }
  }
  .order-search-box {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 10px;
    .order-search-left {
      padding: 0px 10px 0px 0px;
      .left-img {
        width: 60px;
        height: 60px;
      }
    }
    .order-search-center {
      padding: 0px 10px 0px 0px;
      width: -webkit-fill-available;
      .top-search {
        padding: 0px;
        .van-cell {
          padding: 0px 10px 0px 0px;
        }
        /deep/ .van-field__control {
          padding: 0px 15px;
        }
      }
    }
    .order-search-right {
      padding: 10px 0px 0px 0px;
      .right-img {
        width: 50px;
        height: 50px;
      }
    }
  }

  .tab-box {
    padding-bottom: 15px;
  }
  .order-list-box {
    .list-box {
      height: 100%;
      margin-top: 0px;
      .list-title {
        display: flex;
        height: 40px;
        background: #999;
        border-radius: 20px 20px 0px 0px;
        padding: 0px 10px;
        align-items: center;
        text-align: left;
        font-size: 14px;
        color: #000;
        .list-title-orderNo {
          width: 24%;
          padding-right: 15px;
          text-align: center;
        }
        // .list-title-cshNo {
        //   width: 14%;
        // }
        .list-title-customer {
          width: 25%;
        }
        .list-title-date {
          width: 18%;
          padding-left: 5px;
        }
        .list-title-status {
          width: 14%;
          padding-left: 5px;
        }
        .list-title-amt {
          padding-left: 8px;
        }
      }
      .list-ul {
        border-radius: 0px 0px 20px 20px;
        margin-bottom: 20px;
        .list-li {
          display: flex;
          height: 50px;
          border-bottom: 1px solid #dcdcdc;
          align-items: center;
          text-align: left;
          margin: 0px 3px 0px 3px;
        }
        .list-content {
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          padding-right: 3px;
        }
        .list-content1 {
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          padding-right: 3px;
        }
      }
    }
  }
  /deep/ .van-picker__cancel,
  /deep/ .van-picker__confirm {
    font-size: 18px;
  }
  /deep/ .van-hairline--top-bottom::after {
    border: 0px;
  }
}
</style>